// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.iseLcn, .dGQKmy  {
  font-size: 14px !important;
  background-color: rgb(237, 237, 237) !important;
}
.hIidFV, .bNSLrS {
  font-size: 14px !important;
}

.geJtFr{
  background-color: rgb(237, 237, 237) !important;
}
.css-i3xbtr-MuiPaper-root-MuiPopover-paper-MuiMenu-paper,.css-1bf6xnj-MuiPaper-root-MuiPopover-paper-MuiMenu-paper
{

  /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px !important; */
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 4px !important;;
}
.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root:hover
{
 background-color: #FF9933 !important;
 color: #fff;
} 
.removePerksFromlist{
  position: absolute;
    top: 8px;
    right: 15px;
    color: red;
}

.positionrelative{
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;iBAEe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;AACA;;;EAGE,4DAA4D;EAC5D,wDAAwD;AAC1D;AACA;;CAEC,oCAAoC;CACpC,WAAW;AACZ;AACA;EACE,kBAAkB;IAChB,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["body {\r\n  margin: 0;\r\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif; */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n.iseLcn, .dGQKmy  {\r\n  font-size: 14px !important;\r\n  background-color: rgb(237, 237, 237) !important;\r\n}\r\n.hIidFV, .bNSLrS {\r\n  font-size: 14px !important;\r\n}\r\n\r\n.geJtFr{\r\n  background-color: rgb(237, 237, 237) !important;\r\n}\r\n.css-i3xbtr-MuiPaper-root-MuiPopover-paper-MuiMenu-paper,.css-1bf6xnj-MuiPaper-root-MuiPopover-paper-MuiMenu-paper\r\n{\r\n\r\n  /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px !important; */\r\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 4px !important;;\r\n}\r\n.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root:hover\r\n{\r\n background-color: #FF9933 !important;\r\n color: #fff;\r\n} \r\n.removePerksFromlist{\r\n  position: absolute;\r\n    top: 8px;\r\n    right: 15px;\r\n    color: red;\r\n}\r\n\r\n.positionrelative{\r\n  position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
